import _slicedToArray from "/home/runner/work/thesensetech/thesensetech/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from "react";
import { useUnmountEffect } from "./use-unmount-effect";
export function useForceUpdate() {
  var unloadingRef = React.useRef(false);

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      count = _React$useState2[0],
      setCount = _React$useState2[1];

  useUnmountEffect(function () {
    unloadingRef.current = true;
  });
  return React.useCallback(function () {
    if (!unloadingRef.current) {
      setCount(count + 1);
    }
  }, [count]);
}